import React from 'react';
import type { AreaId } from '../../../types/pulse';
import { followUps } from '../../../data/pulse';
import { SelectCue } from '../SelectCue';
interface FollowUpScreenProps {
  area: AreaId;
  selected: string | null;
  onSelect: (id: string) => void;
  freeText: string;
  onFreeText: (text: string) => void;
}
export function FollowUpScreen({
  area,
  selected,
  onSelect,
  freeText,
  onFreeText
}: FollowUpScreenProps) {
  const block = followUps[area];
  return <div className="flex flex-1 flex-col" data-id="element-212" data-mp="1lx64az90gwg5">
      <h2 className="font-display text-[21px] font-semibold leading-[1.15] tracking-tight text-navy" data-id="element-213" data-mp="1gzea1ykw8y8s">
        {block.question}
      </h2>

      <div className="mt-5" data-id="element-214" data-mp="1c3fgzxomes21">
        <SelectCue options={block.options} selected={selected} onSelect={onSelect} freeText={freeText} onFreeText={onFreeText} data-id="element-215" data-mp="172hyfjzp7w00" />
      </div>
    </div>;
}